import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Router } from '@angular/router';
import { startOfMonth, endOfMonth, getISOWeek, eachDayOfInterval, startOfWeek, endOfWeek, format, eachWeekOfInterval, getWeek, subWeeks, eachMonthOfInterval } from "date-fns";
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil, debounceTime, filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { SmartPowerReportBackGroundColor, monthMap, reportTypeOption, SmartPowerReportGrade, reportType, MailRecipientType, updateInfoType, MailModuleType, PackageList, SmartPowerReportPlan } from '../../shareModel';
import * as fromFeature from '../../my-features';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { CryptoService } from '../../services/crypto.service';
import {TranslateService} from '@ngx-translate/core';
interface WeekInfo {
  id: number;
  weekNumber: number;
  startDate: Date;
  endDate: Date;
  startDateStr: string;
  endDateStr: string;
  status?: string;
  riskRate?: string;
  loadDistribution?: string;
  powerProtection?: string;
  // energySaving?: string;
}
interface MonthInfoData {
  id: number;
  month: number;
  status: string;
  riskRate: string;
  loadDistribution: string;
  powerProtection: string;
  // energySaving: string;
}

@Component({
  standalone: false,
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit {
  private componentDestroyed = new Subject();
  private previousValue: any = null;
  UpdateInfoParam = {} as UpdateInfoModel;
  filterDate: Date = new Date();
  selectedWeek: number | null = null;
  selectedMonth: number | null = null
  weekInfoData: WeekInfo[] = [];
  IsSuperAdmin = false;
  IsAdmin = false;
  isMsp = false;
  regionId: number;
  selectRegion = null;

  weeklyData: any[] = [
  ];
  monthlyData: any[] = [
  ];

  monthInfoData = {
    id: 0,
    month: null,
    status: "",
    systemWellness: "",
    loadDistribution: "",
    powerProtection: "",
    // energySaving: "",
  };
  monthInfoArray: MonthInfoData[] = [];

  monthMap = monthMap;
  reportSettingsDialog = false;
  reportSettingDefaultTab: number;
  dialogReportSettingInput = {
    weeklyEnable: false,
    monthlyEnable: false,
    selectedWeeklyCompany: 0,
    selectedMonthlyCompany: 0,
  };
  // weeklyRecipientGroup = [];
  // weeklySelectedGroups = null;
  // monthlyRecipientGroup = [];
  // monthlySelectedGroups = null;
  recipientGroup = [];
  recipientSelectedGroups = null;
  pendingMapGroupIds: number[] = [];
  recipientGroupDialog = false;

  dialogGroupInput = {
    id: 0,
    UpdateType: '',
    GroupName: '',
    Email: 'string',
    Type: 0 // 0(add), 1(edit)
  };

  dialogInput = {
    id: 0,
    UpdateType: '',
    Enable: 0,
    SelectedCompany: 0,
    Group: [],
  };

  groupRecipientMemberList = [];
  currentUser = '';

  lastFiveWeeksOptions: any[] = [{ label: this.translateService.instant('Last 5 Weeks'), value: 'last-5-Weeks' }];
  lastFiveWeeksValue: string = '';
  region = [];
  regionOption = [];
  module_dic = {};
  groups_dic = {};
  dialogSaveDirty = false;
  errMail = false;
  errGroupName = false;
  isUiInitialized = false;
  previousGroupIds: number[] = [];
  allGroupsMemberList = [];
  emailLimit = 3; // default
  errLimitExceeded = false;
  groups = [];
  private isRefetching = false;
  planInfo: any;
  smartPowerReportPlan = SmartPowerReportPlan;

  constructor(
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private cryptoService: CryptoService,
    private store: Store<fromStore.State>,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {
    this.store.pipe(select(fromStore.getCurrentUser)).pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      if (user != undefined && !user.isLoading && user.isLoaded && user.isLogin) {
        this.currentUser = user.currentUser;
        this.IsSuperAdmin = user.authority === 2;
        this.IsAdmin = user.authority && user.authority > 0 ? true : false;
        this.isMsp = user.isMsp;
        this.regionId = user.RegionId;
        this.lastFiveWeeksValue = 'last-5-Weeks';
        this.filterDate = new Date();
        this.filterReportList();
      }
    });

    this.store
      .select(fromStore.getRegions)
      .pipe(takeUntil(this.componentDestroyed))
.subscribe((res) => {
        if (res.length > 0 && this.isMsp) {
          this.region = res;
        }
      });


    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res !== null) {
        if (res.isMsp && res.filterLoaded) {
          if (this.region !== undefined && this.region.length > 0) {
            this.regionOption = [];
            if (res.selectedId && res.selectedId.length > 0) {
              [...this.region].sort((a: any, b: any) => a.Id - b.Id).forEach(r => {
                if (res.selectedId.includes(r.Id)) {
                  if (this.regionOption.length === 0) {
                    this.selectRegion = r.Id;
                  }
                  this.regionOption.push({
                    label: r.Region,
                    value: r.Id
                  });
                }
              });
            } else {
              this.selectRegion = null;
            }
          }
          this.filterReportList();
        }
      }
    });

    this.store.select(fromStore.getUpdateInfoState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {

        const isTargetAction =
          res.type === updateInfoType.AddMailGroup ||
          // res.type === updateInfoType.UpdateMailModule ||
          res.type === updateInfoType.UpdateMailGroup ||
          res.type === updateInfoType.DeleteMailGroup;

        if (isTargetAction) {
          if (!res.isLoading && res.isLoaded) {

            this.messageService.clear(); // 清空舊訊息
            if (res.isSaved) {
              if (res.type === updateInfoType.DeleteMailGroup) {
                this.messageService.add({ severity: 'success', summary: this.translateService.instant('Delete Success') });
              } else {
                this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success') });
              }
              // 清除狀態
              this.errLimitExceeded = false;
              this.errMail = false;
              this.store.dispatch(new fromFeature.GetMailModuleList({ otp: '', ModuleType: 0 }));
              this.store.dispatch(new fromFeature.GetMailGroupList({ otp: '', MailGroupIds: [] }));

            } else {
              this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
            }

            this.resetUpdateInfoState();
            this.ngxService.stop();
          }
        }
      });

    // Get Plan Account Setting
    this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        const usingPlan = Object.values(res.entities).find((i: any) => i.Status === 1) as any;  // filter out using one.
        if (usingPlan) {
          this.planInfo = usingPlan;
        }
        let authFlag = false
        if ((this.planInfo !== undefined && this.planInfo.Level >= this.smartPowerReportPlan.level && this.planInfo.NodeTotal >= this.smartPowerReportPlan.nodes) || this.isMsp) {
          authFlag = true
        }
        if (!authFlag) {
          this.router.navigate(['index']);
        }
      }
    });

    this.store.select(fromStore.GetSmartPowerReportList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res != undefined) {

        let targetDate: Date;
        if (res.length > 0) {
          const weeklylist = [];
          const monthlist = [];
          let latestTime = 0;

          res.forEach(r => {
            const currentReportTime = new Date(r.ReportDate || r.StartDate).getTime();
            if (currentReportTime > latestTime) {
              latestTime = currentReportTime;
            }

            let backGroundStatus = "";
            if (r.SystemStabilityGrade == 4 || r.LoadDistributionGrade == 4 || r.PowerQualityGrade == 4) {
              backGroundStatus = SmartPowerReportBackGroundColor[0]; // poor
            } else if (r.SystemStabilityGrade == 3 || r.LoadDistributionGrade == 3 || r.PowerQualityGrade == 3) {
              backGroundStatus = SmartPowerReportBackGroundColor[1]; // average
            } else if (r.SystemStabilityGrade == 2 || r.LoadDistributionGrade == 2 || r.PowerQualityGrade == 2) {
              backGroundStatus = SmartPowerReportBackGroundColor[2]; // good
            } else if (r.SystemStabilityGrade == 1 || r.LoadDistributionGrade == 1 || r.PowerQualityGrade == 1) {
              backGroundStatus = SmartPowerReportBackGroundColor[3]; // excellent
            }

            if (r.ReportType == reportType['Weekly']) {
              const item = {
                id: r.Id,
                week: r.Week,
                status: backGroundStatus,
                systemWellness: r.SystemStabilityGrade,
                loadDistribution: r.LoadDistributionGrade,
                powerProtection: r.PowerQualityGrade,
                // energySaving: r.EnergyConsumptionGrade,
                powerEvents: r.PowerEvents,
                riskRate: r.RiskRate,
                loadDistributionLimit: r.PeakLoadLv4Cnt + r.PeakLoadLv5Cnt + r.PeakLoadLv6Cnt,
              }
              weeklylist.push(item)
            } else {
              const month = new Date(r.ReportDate).getUTCMonth() + 1; // 取得月份
              const item = {
                id: r.Id,
                month: month,
                status: backGroundStatus,
                systemWellness: r.SystemStabilityGrade,
                loadDistribution: r.LoadDistributionGrade,
                powerProtection: r.PowerQualityGrade,
                // energySaving: r.EnergyConsumptionGrade,
                powerEvents: r.PowerEvents,
                riskRate: r.RiskRate,
                loadDistributionLimit: r.PeakLoadLv4Cnt + r.PeakLoadLv5Cnt + r.PeakLoadLv6Cnt,
              }
              monthlist.push(item)
            }
          });

          this.weeklyData = weeklylist;
          this.monthlyData = monthlist;

          const latestReportDate = latestTime > 0 ? new Date(latestTime) : this.filterDate;

          // 有資料時，依據 lastFiveWeeksValue 決定使用最新報表日期或 UI 選擇日期
          targetDate = this.lastFiveWeeksValue ? latestReportDate : this.filterDate;

        } else {
          this.weeklyData = [];
          this.monthlyData = [];
          // 如果是「選擇特定月份」，就必須維持使用者在日曆選的那個日期
          targetDate = this.lastFiveWeeksValue ? new Date() : this.filterDate;
        }


        // 把決定好的 targetDate 丟進去算 (不論有沒有資料都會執行，藉此更新/清空畫面)
        this.calculateWeekNumbers(targetDate);
        this.calculateMonthNumbers(targetDate);
      }
    });

    // Mapping Module & Groups
    combineLatest([this.store.select(fromStore.GetMailModule), this.store.select(fromStore.GetMailGroup)])
  .pipe(takeUntil(this.componentDestroyed))
  .subscribe(([moduleObj, groups]) => {

    this.module_dic = {};
    this.groups_dic = {};
    const newRecipientGroup = [];

    // 固定塞入 "寄給自己"
    newRecipientGroup.push({
      id: -1,
      GroupName: this.currentUser,
      GroupMember: ""
    });

    this.groups = groups || { Data: [] };
    this.resetAllGroupsMemberList();

    if (groups && groups.Data && groups.Data.length > 0) {
      this.groups = groups;
      this.resetAllGroupsMemberList();
      groups.Data.forEach(g => {
        const membersStr = (!g.Members || g.Members.length === 0) ? '' : g.Members.map((m: any) => m.Email).join(',');

        newRecipientGroup.push({
          id: g.GroupId,
          GroupName: g.GroupName,
          GroupMember: membersStr
        });
        if (g.IsChecked === true || g.IsChecked === 1) { // 加上 === 1 是防呆後端可能傳數字
          if (!this.pendingMapGroupIds) {
            this.pendingMapGroupIds = [];
          }
          if (!this.pendingMapGroupIds.includes(g.GroupId)) {
            this.pendingMapGroupIds.push(g.GroupId);
          }
        }
      });
    }
    this.recipientGroup = newRecipientGroup;

    // 確保等待名單陣列存在
    if (!this.pendingMapGroupIds) {
      this.pendingMapGroupIds = [];
    }

    // 初始化解析：只抓取 Module 設定，並把目標 ID 放入「等待名單」
    if (!this.isUiInitialized && moduleObj) {

      this.dialogReportSettingInput = {
        weeklyEnable: false,
        monthlyEnable: false,
        selectedWeeklyCompany: 0,
        selectedMonthlyCompany: 0,
      };
      this.recipientSelectedGroups = [];
      this.pendingMapGroupIds = []; // 初始化時清空等待名單

      if (moduleObj.IsSendToMe === 1 || moduleObj.IsSendToMe === true) {
        this.pendingMapGroupIds.push(-1);
      }

      if (moduleObj.Data && moduleObj.Data.length > 0) {
        moduleObj.Data.forEach(m => {
          if (m.ModuleSubType == reportType['Weekly']) {
            this.dialogReportSettingInput.weeklyEnable = true;
          } else if (m.ModuleSubType == reportType['Monthly']) {
            this.dialogReportSettingInput.monthlyEnable = true;
          }

          if (m.MailGroupIds && m.MailGroupIds.length > 0) {
            m.MailGroupIds.forEach(id => {
              if (!this.pendingMapGroupIds.includes(id)) {
                this.pendingMapGroupIds.push(id);
              }
            });
          }
        });
      }

      this.isUiInitialized = true;
    }

    // 嘗試配對：不論 Group 晚多久回來，每次都檢查等待名單
    if (!this.recipientSelectedGroups) {
      this.recipientSelectedGroups = [];
    }
    if (this.pendingMapGroupIds && this.pendingMapGroupIds.length > 0) {
      // 使用 filter 反向操作：如果配對成功，就 return false 把 ID 從等待名單移除
      this.pendingMapGroupIds = this.pendingMapGroupIds.filter(pendingId => {
        const target = this.recipientGroup.find(x => x.id === pendingId);
        if (target) {
          // 找到了！把真實的 Group 物件塞進已選清單中
          if (!this.recipientSelectedGroups.includes(target)) {
            this.recipientSelectedGroups.push(target);
          }
          return false;
        }
        return true; 
      });
    }

    // 收尾防呆：確保畫面上打勾的群組，真的都還存活於最新的資料庫中
    if (this.isUiInitialized) {
      const currentSelectedIds = this.recipientSelectedGroups.map(x => x.id);
      this.recipientSelectedGroups = this.recipientGroup.filter(x => currentSelectedIds.includes(x.id));
    }
  });

    this.store
      .pipe(select(fromStore.getUserAllModule))
      .pipe(takeUntil(this.componentDestroyed))
.subscribe((res) => {
        if (res && Object.keys(res).length > 0) {
          const addEmailObj = res[PackageList.AddEmail];
          const emailLimitObj = res[PackageList.EmailLimit];
          if (addEmailObj && emailLimitObj && addEmailObj.Value === '1') {
            this.emailLimit = parseInt(emailLimitObj.Value, 10);
          }
        }
      });
  }

  ngOnInit() {
    this.ngxService.start();
    this.UI();
    // this.lastFiveWeeksValue = this.lastFiveWeeksOptions[0].value;
    // this.getLastFiveWeeks();
    this.ngxService.stop();
  }

  getCalendarWeekClass(weekInfo: WeekInfo): string {
    return weekInfo.status || "disabled";
  }

  UI() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("body-landing");
    body.classList.remove("body-login");
    body.classList.remove("mobile-toggle");
  }

  onMonthChange(event: any): void {
    this.filterDate = event;
    this.lastFiveWeeksValue = null;
    this.calculateWeekNumbers(this.filterDate);
    this.calculateMonthNumbers(this.filterDate);
    this.filterReportList(this.filterDate);
  }

  selectWeek(week: WeekInfo): void {
    this.selectedWeek = week.weekNumber;
    // console.log(
    //   `已選擇第 ${week.weekNumber} 週 (${week.startDateStr} - ${week.endDateStr})`
    // );
    let paramStr = '';
    // weeklyType,startTs,endTs 提供參數給Report Filter
    const weekType = 0;
    paramStr = paramStr + weekType + ',' + week.id + ',' + (new Date(week.startDate).getTime() / 1000) + ',' + (new Date(week.endDate).getTime() / 1000);
    const hashStr = this.cryptoService.aesEncrypt(paramStr)
    this.router.navigate(['smart-power-report/report/', hashStr]);
  }

  selectMonth(monthNumber: number) {
    // 1. 從陣列中找出被點選的那個月份的資料
    const targetMonthData = this.monthInfoArray.find(m => m.month === monthNumber);

    // 防呆機制：如果找不到該月份資料就結束執行
    if (!targetMonthData) return;

    // 2. 使用找到的資料來賦值
    this.selectedMonth = targetMonthData.month;

    let paramStr = '';
    const monthType = 1;
    const year = new Date().getFullYear(); // 取得今年

    // 3. 這裡的月份計算也要改成 targetMonthData.month
    const start = new Date(year, (targetMonthData.month - 1), 1, 0, 0, 0, 0);
    const end = new Date(year, targetMonthData.month, 0, 23, 59, 59, 999);

    const startTimestamp = start.getTime() / 1000;
    const endTimestamp = end.getTime() / 1000;

    // 4. 這裡的 id 也要改成 targetMonthData.id
    paramStr = paramStr + monthType + ',' + targetMonthData.id + ',' + startTimestamp + ',' + endTimestamp;

    const hashStr = this.cryptoService.aesEncrypt(paramStr);
    this.router.navigate(['smart-power-report/report/', hashStr]);
  }

  calculateWeekNumbers(inputDate: Date): void {
    if (!inputDate) {
      this.weekInfoData = [];
      return;
    }

    let periodStart: Date;
    let periodEnd: Date;

    if (this.lastFiveWeeksValue) {
      let currentWeekStart = startOfWeek(inputDate, { weekStartsOn: 0 });
      const latestIsoWeek = getISOWeek(currentWeekStart);

      const hasLatestWeekData = this.weeklyData.some((item) => item.week === latestIsoWeek);

      if (!hasLatestWeekData) {
        currentWeekStart = subWeeks(currentWeekStart, 1);
      }

      periodStart = subWeeks(currentWeekStart, 4);
      periodEnd = endOfWeek(currentWeekStart, { weekStartsOn: 0 });
      
    } else {
      periodStart = startOfMonth(inputDate);
      periodEnd = endOfMonth(inputDate);
    }

    // 取得區間內的週陣列
    const weeksInterval = eachWeekOfInterval({
      start: periodStart,
      end: periodEnd
    }, { weekStartsOn: 0 });

    let rawWeekInfoData = weeksInterval.map((weekStart) => {
      const isoWeek = getISOWeek(weekStart);

      const sDate = startOfWeek(weekStart, { weekStartsOn: 0 });
      const eDate = endOfWeek(weekStart, { weekStartsOn: 0 });

      const startStr = format(sDate, 'MM/dd');
      const endStr = format(eDate, 'MM/dd');

      const weekData = this.weeklyData.find((item) => item.week === isoWeek);

      const weekInfo: WeekInfo = {
        id: 0,
        weekNumber: isoWeek,
        startDate: sDate,
        endDate: eDate,
        startDateStr: startStr,
        endDateStr: endStr,
        riskRate: "-",
        loadDistribution: "-",
        powerProtection: "-",
        // energySaving: "-",
      };

      if (weekData) {
        weekInfo.id = weekData.id;
        weekInfo.status = weekData.status;
        weekInfo.riskRate = this.reportToScorePipe("riskRate", weekData.riskRate);
        weekInfo.loadDistribution = this.reportToScorePipe("loadDistribution", weekData.loadDistributionLimit);
        weekInfo.powerProtection = this.reportToScorePipe("powerProtection", weekData.powerEvents);
        // weekInfo.energySaving = this.reportToScorePipe("energySaving", weekData.energySaving);
      }
      return weekInfo;
    });

    if (!this.lastFiveWeeksValue) {
      const targetMonth = inputDate.getMonth();
      rawWeekInfoData = rawWeekInfoData.filter(info => info.startDate.getMonth() === targetMonth);
    }

    this.weekInfoData = rawWeekInfoData;
    this.selectedWeek = getISOWeek(inputDate);
  }

  calculateMonthNumbers(inputDate: Date): void {
    if (!inputDate) {
      this.monthInfoArray = []; // 注意：這裡需將型別改為陣列
      return;
    }

    let periodStart: Date;
    let periodEnd: Date;

    if (this.lastFiveWeeksValue) {
      let currentWeekStart = startOfWeek(inputDate, { weekStartsOn: 0 });
      const latestIsoWeek = getISOWeek(currentWeekStart);

      const hasLatestWeekData = this.weeklyData.some((item) => item.week === latestIsoWeek);

      if (!hasLatestWeekData) {
        currentWeekStart = subWeeks(currentWeekStart, 1);
      }

      periodStart = subWeeks(currentWeekStart, 4);
      periodEnd = endOfWeek(currentWeekStart, { weekStartsOn: 0 });
      
    } else {
      periodStart = startOfMonth(inputDate);
      periodEnd = endOfMonth(inputDate);
    }

    // 取得這個區間內涵蓋的所有月份
    const monthsInterval = eachMonthOfInterval({
      start: periodStart,
      end: periodEnd
    });

    //  把每一個月份的資料對應出來，並存成陣列
    this.monthInfoArray = monthsInterval.map(monthDate => {
      const currentMonth = monthDate.getMonth() + 1;
      const monthData = this.monthlyData.find(
        (item) => item.month === currentMonth
      );

      if (monthData) {
        return {
          id: monthData.id,
          month: currentMonth,
          status: monthData.status || "",
          riskRate: this.reportToScorePipe("riskRate", monthData.riskRate),
          loadDistribution: this.reportToScorePipe("loadDistribution", monthData.loadDistributionLimit),
          powerProtection: this.reportToScorePipe("powerProtection", monthData.powerEvents),
          // energySaving: this.reportToScorePipe("energySaving", monthData.energySaving)
        };
      } else {
        return {
          id: 0,
          month: currentMonth,
          status: "disabled",
          riskRate: "-",
          loadDistribution: "-",
          powerProtection: "-",
          // energySaving: "-"
        };
      }
    });

    this.selectedMonth = inputDate.getMonth() + 1;
  }

  reportToScorePipe(type, value) {
    if ( value === null || value === undefined || typeof value !== "number" || isNaN(value)) {
      return "-";
    }
    // const primaryValue: string = value;
    return String(value);
  }

  showReportSetting() {
    // 取得Module資訊
    const module_param = {
      otp: '',
      ModuleType: 0
    }
    this.store.dispatch(new fromFeature.GetMailModuleList(module_param));


    // 取得Group資訊
    const group_param = {
      otp: '',
      MailGroupIds: [] //取全部
    }
    this.store.dispatch(new fromFeature.GetMailGroupList(group_param));
    this.reportSettingsDialog = true;
  }

  onTabChange(event) {
    this.reportSettingDefaultTab = event.index;
  }

  saveRecipientSetting() {
    const dataArray = [];
    let isSendToMeChecked = false;
    
    // 把 selectedIds 提到外層，因為等一下更新 Group 狀態時也會用到
    let selectedIds: number[] = [];

    if (this.dialogReportSettingInput.weeklyEnable || this.dialogReportSettingInput.monthlyEnable) {

      // 判斷有沒有勾選「寄給自己 (-1)」
      isSendToMeChecked = this.recipientSelectedGroups.some(g => g.id === -1);

      // 把正常群組的 ID 抽出來
      selectedIds = this.recipientSelectedGroups.filter(g => g.id !== -1).map(g => g.id);

      // 假設 Weekly 開啟
      if (this.dialogReportSettingInput.weeklyEnable) {
        dataArray.push({
          ModuleSubType: 0, // Weekly
          MailGroupIds: selectedIds,
          Members: []
        });
      }

      // 假設 Monthly 開啟
      if (this.dialogReportSettingInput.monthlyEnable) {
        dataArray.push({
          ModuleSubType: 1, // Monthly
          MailGroupIds: selectedIds,
          Members: []
        });
      }
    }

    // 1. 更新報表設定 (Module)
    const moduleParams = {
      otp: '',
      ModuleType: MailModuleType['SmartPowerReport'],
      IsSendToMe: isSendToMeChecked,
      Data: dataArray
    };
    this.store.dispatch(new fromFeature.UpdateMailModule(moduleParams));

    // 2. 批次更新群組狀態
    const groupUpdateData = [];

    // 巡覽畫面上所有的真實群組 (排除寄給自己 id: -1)
    this.recipientGroup.filter(g => g.id !== -1).forEach(g => {
      
      // 判斷這個群組這次有沒有被勾選
      const isGroupChecked = selectedIds.includes(g.id);

      const originalGroup = this.groups_dic[g.id];
      const formattedMembers = [];

      if (originalGroup && originalGroup.Members) {
        originalGroup.Members.forEach((m: any) => {
          formattedMembers.push({
            Email: m.Email,
            RecipientType: m.RecipientType || MailRecipientType['0'] // 保持原本的 Type
          });
        });
      }

      // 把要更新的資料塞進陣列
      groupUpdateData.push({
        MailGroupId: g.id,
        GroupName: g.GroupName,
        IsChecked: isGroupChecked,  // <--- 同步最新的勾選狀態
        Members: formattedMembers   // <--- 把原本的信箱塞回去，保護資料不被洗掉
      });
    });

    // 如果有群組需要更新，就發送 UpdateMailGroup Action
    if (groupUpdateData.length > 0) {
      const groupUpdateParam = {
        otp: '',
        data: groupUpdateData
      };
      this.store.dispatch(new fromFeature.UpdateMailGroup(groupUpdateParam));
    }

    // 關閉 Dialog
    this.reportSettingsDialog = false;
  }

  showAddGroupDialog(period) {
    this.dialogGroupInput = {
      id: 0,
      UpdateType: this.translateService.instant('Add Recipient Group'),
      GroupName: '',
      Email: '',
      Type: 0
    };
    this.groupRecipientMemberList = [];
    this.dialogSaveDirty = false;
    this.errLimitExceeded = false; // 防呆清除
    this.errMail = false;          // 防呆清除

    // 開啟前先洗乾淨全域清單
    this.resetAllGroupsMemberList();

    this.recipientGroupDialog = true;
  }

  showEditGroupDialog(rowData) {
    this.dialogGroupInput = {
      id: rowData.id,
      UpdateType: this.translateService.instant('Edit Recipient Group'),
      GroupName: rowData.GroupName,
      Email: '',
      Type: 1
    };

    this.groupRecipientMemberList = [];
    this.errLimitExceeded = false; // 防呆清除
    this.errMail = false;          // 防呆清除

    // 開啟前先洗乾淨全域清單
    this.resetAllGroupsMemberList();

    if (this.groups_dic && this.groups_dic[rowData.id]) {
      const targetGroup = this.groups_dic[rowData.id];
      if (targetGroup && Array.isArray(targetGroup.Members)) {
        this.groupRecipientMemberList = targetGroup.Members.map((email, index) => ({
          id: index + 1,
          Email: email.Email
        }));

      }
    }
    this.recipientGroupDialog = true;
  }

  controlGroupMember(result: string) {
    if (result === 'addGroupMember') {
      this.checkEmail();
      const inputEmail = this.dialogGroupInput.Email;
      if (!inputEmail || inputEmail.trim() === '') return;

      const cleanEmail = inputEmail.trim().toLowerCase();

      // 1. 檢查「當前畫面」有沒有重複
      const isEmailExistInCurrent = this.groupRecipientMemberList.some(
        member => member.Email.trim().toLowerCase() === cleanEmail
      );
      if (isEmailExistInCurrent) {
        this.errMail = true;
        return;
      }

      // 2. 檢查「全域清單」有沒有重複 
      // console.log('1. 現在要檢查的信箱是:', cleanEmail);
      // console.log('2. 目前的全域清單長這樣:', this.allGroupsMemberList);
      if (this.allGroupsMemberList.includes(cleanEmail)) {
        this.errMail = true;
        return;
      }

      // 3. 檢查數量上限：全域的數量 + 這一次在畫面上新增的數量
      // 計算方式：全域原本的長度 + (當前畫面陣列長度 - 編輯前該群組原始長度)
      let currentTotalEmails = this.allGroupsMemberList.length;

      if (this.emailLimit !== undefined && currentTotalEmails >= this.emailLimit) {
        this.errLimitExceeded = true;
        return;
      }

      this.errMail = false;
      this.errLimitExceeded = false;

      const maxId = this.groupRecipientMemberList.length > 0
        ? Math.max(...this.groupRecipientMemberList.map(m => m.id))
        : 0;

      // 加進當前畫面清單
      this.groupRecipientMemberList.push({ id: maxId + 1, Email: inputEmail.trim() });
      this.allGroupsMemberList.push(cleanEmail);
      this.dialogGroupInput.Email = '';
    }
  }

resetAllGroupsMemberList() {
    this.allGroupsMemberList = [];
    this.groups_dic = {};
    this.groupRecipientMemberList = [];

    if (this.currentUser) {
      this.allGroupsMemberList.push(this.currentUser.trim().toLowerCase());
    }

    // 確保 groups 存在、Data 存在，且 Data 是一個陣列
    if (this.groups && this.groups["Data"] && Array.isArray(this.groups["Data"])) {
      this.groups["Data"].forEach(g => {
        this.groups_dic[g.GroupId] = g;
        
        // 多加一層陣列檢查，確保 Members 真的可以被 forEach
        if (g.Members && Array.isArray(g.Members) && g.Members.length > 0) {
          g.Members.forEach(m => {
            if (m.Email) {
              this.allGroupsMemberList.push(m.Email.trim().toLowerCase());
            }
          });
        }
      });
    }
  }

  checkGroupName() {
    const inputGroupName = this.dialogGroupInput.GroupName;

    if (!inputGroupName || inputGroupName.trim() === '') {
      this.errGroupName = false;
      return;
    }

    // 下面檢查Name重復與空白部分拿掉
    // 這裡維持只去頭尾空白，因為如果他中間打空白，我們要報錯
    // const cleanName = inputGroupName.trim();

    // // 空白移除
    // // 所以只要 cleanName 裡面還有空白，test 就會過不了。
    // const nameRegex = /^[\u4e00-\u9fa5a-zA-Z0-9_\-]+$/;
    // if (!nameRegex.test(cleanName)) {
    //   this.errGroupName = true;
    //   return;
    // }

    // // 檢查是否與現有群組重複
    // const currentEditId = this.dialogGroupInput.id;
    // const isGroupNameExist = this.recipientGroup.some(
    //   g => g.GroupName.trim() === cleanName &&
    //     g.id !== -1 &&
    //     g.id !== currentEditId
    // );

    // this.errGroupName = isGroupNameExist;
  }

  checkEmail() { 
    const inputEmail = this.dialogGroupInput.Email;

    if (!inputEmail || inputEmail.trim() === '') {
      this.errMail = false;
      return;
    }

    // 轉小寫與去空白
    const cleanEmail = inputEmail.trim().toLowerCase();

    // 格式檢查
    const emailRegex = /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailRegex.test(cleanEmail)) {
      this.errMail = true;
      return;
    }

    const isEmailExistInCurrent = this.groupRecipientMemberList.some(
      member => member.Email.trim().toLowerCase() === cleanEmail
    );

    // 檢查「全域清單」有沒有重複
    const isEmailExistInAll = this.allGroupsMemberList.includes(cleanEmail);

    // 只要當前群組「或」全域清單有重複，就觸發錯誤提示
    this.errMail = isEmailExistInCurrent || isEmailExistInAll;
  }

  deleteGroupData(rowData, period) {
    const delete_param = {
      otp: '',
      Ids: [rowData.id]
    };

    this.store.dispatch(new fromFeature.DeleteMailGroup(delete_param));

    this.ngxService.start();
  }

  saveGroupDialog() {
    this.dialogSaveDirty = true;
    if (this.dialogGroupInput.Type === 0) {
      if (this.groupRecipientMemberList.length > 0) {
        const add_param = {
          otp: '',
          data: []
        }
        const group = {
          GroupName: this.dialogGroupInput.GroupName,
          IsChecked: false,
          Members: []
        }
        this.groupRecipientMemberList.forEach(r => {
          const member = {
            Email: r.Email,
            RecipientType: MailRecipientType['0'] // 先預設為To
          }
          group.Members.push(member)
        })
        add_param.data.push(group)

        this.store.dispatch(new fromFeature.AddMailGroup(add_param));
      }
    } else if (this.dialogGroupInput.Type === 1 && this.dialogGroupInput.id > 0) {
      const update_param = {
        otp: '',
        data: []
      };

      const group = {
        MailGroupId: this.dialogGroupInput.id,
        GroupName: this.dialogGroupInput.GroupName,
        Members: []
      };

      this.groupRecipientMemberList.forEach(r => {
        const member = {
          Email: r.Email,
          RecipientType: MailRecipientType['0'] // 預設為 To
        };
        group.Members.push(member);
      });

      update_param.data.push(group);
      this.store.dispatch(new fromFeature.UpdateMailGroup(update_param));
    }

    this.recipientGroupDialog = false;
    this.dialogSaveDirty = false;
  }
  cancelDialog() {
    this.recipientGroupDialog = false;
    this.errLimitExceeded = false;
    this.errMail = false;
    this.resetAllGroupsMemberList();
  }

  deleteRecipientGroupMember(deleteItemIndex, rowdata) {
    if (this.groupRecipientMemberList !== undefined && this.groupRecipientMemberList.length > 0) {
      const emailToDelete = this.groupRecipientMemberList[deleteItemIndex].Email.trim().toLowerCase();

      this.groupRecipientMemberList.splice(deleteItemIndex, 1);

      const globalIndex = this.allGroupsMemberList.indexOf(emailToDelete);
      if (globalIndex !== -1) {
        this.allGroupsMemberList.splice(globalIndex, 1);
      }

      this.errLimitExceeded = false;
      this.errMail = false;
    }
  }

handleButtonClick(event: any) {
  const clickedValue = event.value;
  if (this.previousValue === clickedValue) {
    setTimeout(() => {
      this.lastFiveWeeksValue = null;
      this.previousValue = null;
      this.filterReportList(this.filterDate);
    });
  } else {
    this.previousValue = clickedValue;
    this.lastFiveWeeksValue = clickedValue;
    this.filterDate = new Date();
    this.filterReportList();
  }
}

  filterReportList(date: any = null) {
    const param = {
      otp: ""
    } as any
    if (this.isMsp) {
      if (this.selectRegion !== null) { // 第一次進來還沒選過
        param.RegionId = this.selectRegion;
      } else {
        param.RegionId = this.regionId;
      }
    }
    if (date !== null) {
      param.ReportDate = this.formateFilterDate(date);
    }
    this.store.dispatch(new fromFeature.GetSmartPowerReportList(param));
  }

  formateFilterDate(date: any = null) {
    let d = new Date();
    if (date !== null) {
      d = new Date(date);
    }
    const filterDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`; // 2026-01-01 補0
    return filterDate;
  }

  routeToProAccount() {
    this.router.navigate(['management/pro/account/']);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
